export default __webpack_public_path__ + "media/src/assets/images/chart-tree-e978df294be5be239ae69914f13982ee.svg";